<template>
  <div class="space-between-y">
    <el-dialog
        :visible.sync="detail.dialog"
        width="800"
    >
      <sale-order-detail :id="detail.id" v-if="detail.dialog"></sale-order-detail>
    </el-dialog>

    <el-dialog
        title="订单业务详情"
        :visible.sync="event.dialog"
        width="700"
    >
      <sale-order-event-detail :sale-order-id="event.orderId" v-if="event.dialog"></sale-order-event-detail>
    </el-dialog>

    <el-dialog title="订单收款登记" :sale-order-id="payment.orderId" :visible.sync="payment.dialog" width="600">
      <sale-order-other-payment @updated="paymentUpdated" :sale-order-id="payment.orderId"
                                v-if="payment.dialog"></sale-order-other-payment>
    </el-dialog>


    <div class="space-between-x container-left">
      <input-item width="170" label="请输入关键字搜索">
        <el-input clearable v-model="search.key" placeholder="请输入关键字"></el-input>
      </input-item>
      <input-item width="150" label="根据服务状态筛选">
        <el-select @change="getList" clearable v-model="search.status" placeholder="请选择" filterable>
          <el-option v-for="(item,index) in option.status" :key="index" :label="item.label"
                     :value="item.value"></el-option>
        </el-select>
      </input-item>
      <input-item width="150" label="根据订单来源筛选">
        <el-select @change="getList" clearable v-model="search.client" placeholder="请选择" filterable>
          <el-option v-for="(item,index) in option.clients" :key="index" :label="item.label"
                     :value="item.value"></el-option>
        </el-select>
      </input-item>
      <input-item>
        <el-button type="primary" @click="getList">搜索</el-button>
      </input-item>
    </div>

    <el-table :data="list" stripe border>
      <el-table-column label="#" type="index" width="50"></el-table-column>
      <el-table-column width="200" label="订单" prop="name">
        <template v-slot:default="scope">
          <div class="order">
            <cloud-img
                :url="scope.row.cover || 'https://meefung-wellorg-prd-1256075047.cos.ap-guangzhou.myqcloud.com/manage-interface-static/imgs/%E5%9B%BE%E7%89%87%E5%8A%A0%E8%BD%BD%E5%A4%B1%E8%B4%A5.png'"
                :img-width="45" :img-height="45" :border-radius="4"></cloud-img>
            <div>
              <line-overflow :content="scope.row.name" :max-lines="1"></line-overflow>
              <line-overflow :content="scope.row.number" class="info-text" :max-lines="1"></line-overflow>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="80" label="订单金额" prop="price">
        <template v-slot:default="scope">
          <div class="price">{{ scope.row.price }}</div>
        </template>
      </el-table-column>
      <el-table-column width="160" label="下单用户" prop="createBy">
        <template v-slot:default="scope">
          <line-overflow :content="scope.row.createBy" :max-lines="1"></line-overflow>
          <line-overflow class="info-text" :content="scope.row.createTime" :max-lines="1"></line-overflow>
        </template>
      </el-table-column>
      <el-table-column width="120" label="报名学员" prop="customerName">
        <template v-slot:default="scope">
          <line-overflow :max-lines="1" :content="scope.row.customerName"></line-overflow>
          <line-overflow class="info-text" :max-lines="1" :content="scope.row.phone"></line-overflow>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status">
        <template v-slot:default="scope">
          <sale-order-status :status-code="scope.row.status"></sale-order-status>
        </template>
      </el-table-column>
      <el-table-column label="订单来源" prop="phone">
        <template v-slot:default="scope">
          <el-tag size="mini" type="success" effect="dark" v-if="scope.row.client === 'MIU'">家长端</el-tag>
          <el-tag size="mini" effect="dark" v-if="scope.row.client === 'CUSTOMER'">园长端</el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="190" align="center">
        <template v-slot:default="scope">
          <el-button size="mini" type="text" @click="handlerDetail(scope.row.id)">查看</el-button>
          <el-button :disabled="scope.row.payMethod === 'WECHAT'" size="mini" type="text"
                     @click="handlerPayment(scope.row.id)">
            收款
          </el-button>
          <el-button size="mini" type="text" @click="handlerEvent(scope.row.id)">服务</el-button>
          <el-button size="mini" type="text" disabled>修改</el-button>
          <el-button size="mini" type="text" @click="handlerDel(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-model="page" @updated="getList()"></pagination>
  </div>
</template>

<script>
import {saleorder} from "@/api/saleorder";
import SaleOrderDetail from "@/components/saleOrder/SaleOrderDetail.vue";
import {msg} from "@/assets/js/my-vue-element-ui-js";
import LineOverflow from "@/components/base/layout/text/LineOverflow.vue";
import SaleOrderEventDetail from "@/components/saleOrder/SaleOrderEventDetail.vue";
import SaleOrderStatus from "@/components/saleOrder/SaleOrderStatus.vue";
import {mapActions, mapGetters} from "vuex";
import SaleOrderOtherPayment from "@/components/saleOrder/SaleOrderOtherPayment.vue";
import Pagination from "@/components/base/layout/Pagination.vue";
import InputItem from "@/components/base/layout/InputItem.vue";
import CloudImg from "@/components/base/layout/img/CloudImg.vue";
import EventOrderList from "@/components/eventorder/EventOrderList.vue";

export default {
  name: 'SaleOrderAll',
  components: {
    EventOrderList,
    CloudImg,
    InputItem,
    Pagination,
    SaleOrderOtherPayment,
    SaleOrderStatus, SaleOrderEventDetail, LineOverflow, SaleOrderDetail
  },

  computed: {
    ...mapGetters('saleOrder', ['refreshSalrOrderList'])
  },


  watch: {
    refreshSalrOrderList(newVal) {
      if (newVal) {
        this.getList();
        this.resetRefreshSalrOrderList();
      }
    },
  },

  data() {
    return {
      list: [],
      detail: {
        dialog: false,
        id: "",
      },
      event: {
        orderId: "",
        dialog: false,
      },
      payment: {
        orderId: "",
        dialog: false,
      },


      search: {
        key: "",
        status: null,
        client: "",
      },

      page: {
        size: 10,
        current: 1,
        total: 0,
      },

      option: {
        status: [
          {label: "已提交", value: 1},
          {label: "已支付", value: 2},
          {label: "服务中", value: 3},
          {label: "待评价", value: 4},
          {label: "完成", value: 5}
        ],
        clients: [
          {label: "园长端", value: "CUSTOMER"},
          {label: "家长端", value: "MIU"},
        ],
      },


    };
  },

  created() {
    this.getList();
  },
  methods: {
    ...mapActions('saleOrder', ['resetRefreshSalrOrderList']),

    paymentUpdated() {
      this.getList();
      this.payment.dialog = false;
      this.payment.orderId = "";
    },


    handlerPayment(id) {
      this.payment.orderId = id;
      this.payment.dialog = true;
    },

    handlerDetail(id) {
      this.detail.id = id;
      this.detail.dialog = true;
    },
    getList() {
      saleorder.listAll(this.page.size, this.page.current, this.search.key, this.search.status, this.search.client).then(page => {
        this.list = page?.list;
        this.page.total = page?.total;
      });
    },
    handlerDel(id) {
      this.$confirm("确定删除吗？").then(() => {
        saleorder.delete(id).then(res => {
          msg(res, this);
          if (res.code === 200) {
            this.getList();
          }
        })
      }).catch(() => {
      })
    },

    handlerEvent(id) {
      this.event.orderId = id;
      this.event.dialog = true;
    },
  },


};
</script>

<style scoped>
.order {
  display: flex;
  flex-flow: row;
  gap: 6px;
}

.price {
  font-weight: bold;
  font-size: 15px;
}

</style>
